@if (show()) {
    <div class="loading-overlay d-flex">
        <div class="w-100 d-flex justify-content-center align-items-center flex-column">
            <p class="text-muted mt-2">{{ text$ | async }}</p>
        </div>
    </div>
}